import React, { useEffect, useState } from "react";
import { ArrowLeftRight } from "lucide-react";

// Staff-facing, READ-ONLY view of the caller's own transfer requests. Self-hides
// (renders null) when the caller has none. /mine returns a BARE ARRAY of all
// statuses. Status vocab: pending | completed | rejected (terminal success is
// "completed", NOT "approved").

const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:8000";
const card = "rounded-xl border border-[#00ff90]/30 bg-[#0d0d0d] shadow-[0_0_12px_#00ff9022]";

const STATUS_STYLE = {
  pending:   "text-amber-400 bg-amber-500/10 border-amber-500/25",
  completed: "text-[#00ff90] bg-[#00ff90]/10 border-[#00ff90]/25",
  rejected:  "text-red-400 bg-red-500/10 border-red-500/20",
};
const STATUS_FALLBACK = "text-white/30 bg-white/5 border-white/10";
const STATUS_LABEL = { pending: "Pending", completed: "Completed", rejected: "Rejected" };
const TYPE_LABEL = { department: "Department", reporting_line: "Reporting Line", location: "Location", role: "Role" };

const fmtDate = (d) => (d ? String(d).slice(0, 10) : "—");
const val = (v) => (v === null || v === undefined || v === "" ? "—" : v);
const statusBadge = (s) => (
  <span className={`text-xs px-2 py-0.5 rounded-full border ${STATUS_STYLE[s] || STATUS_FALLBACK}`}>{STATUS_LABEL[s] || s || "—"}</span>
);

export default function MyTransferCard() {
  const [items, setItems] = useState(null); // null = loading, [] = none
  const token = localStorage.getItem("token");

  useEffect(() => {
    let active = true;
    fetch(`${API_BASE}/api/performance/transfers/mine`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => (r.ok ? r.json() : []))
      .then(d => { if (active) setItems(Array.isArray(d) ? d : []); })
      .catch(() => { if (active) setItems([]); });
    return () => { active = false; };
  }, [token]);

  if (!items || items.length === 0) return null; // quiet empty state, never an error

  return (
    <div className={`${card} p-5 space-y-3`}>
      <div className="flex items-center gap-2">
        <ArrowLeftRight size={16} className="text-[#00ff90] shrink-0" />
        <p className="text-xs text-[#00ff90]/60 uppercase tracking-widest font-medium">Transfers</p>
      </div>

      <div className="space-y-2">
        {items.map((t) => (
          <div key={t.id} className="rounded-lg border border-white/5 bg-white/3 p-3 space-y-1.5">
            <div className="flex items-center justify-between gap-2 flex-wrap">
              <span className="text-sm text-white/80 font-medium">{TYPE_LABEL[t.transfer_type] || t.transfer_type}</span>
              {statusBadge(t.status)}
            </div>
            <div className="text-xs text-white/50 space-y-0.5">
              <p>Department: <span className="text-white/70">{val(t.from_department)} → {val(t.to_department)}</span></p>
              <p>Manager: <span className="text-white/70">{val(t.from_manager_name)} → {val(t.to_manager_name)}</span></p>
              <p>Title: <span className="text-white/70">{val(t.from_title)} → {val(t.to_title)}</span></p>
              <p className="text-white/30">Effective: {fmtDate(t.effective_date)}</p>
            </div>
            {(t.status === "completed" || t.status === "rejected") && t.approval_notes && (
              <p className="text-xs text-white/50">
                <span className="text-white/30">{t.status === "rejected" ? "Reason: " : "HR note: "}</span>{t.approval_notes}
              </p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
